import React from 'react';
import ClientOrderReceiptsButtonProperties from "./ClientOrderReceiptsButtonProperties";
import RoundedButton from "../../../ui_components/RoundedButton/RoundedButton";
import {Observer} from "mobx-react-lite";
import {useStyles} from "./ClientOrderReceiptsButton.style";
import Button from "../../../ui_components/Button/Button";
import ButtonType from "../../../ui_components/Button/ButtonType";
import {useCommonContext} from "../../../contexts/CommonContext";
import ButtonSize from "../../../ui_components/Button/ButtonSize";
import ClientOrderReceiptsStore from './ClientOrderReceiptsStore';
import SidePanel from '../../../ui_components/SidePanel/SidePanel';
import ViewSingleBatchReceipt from '../ViewBatchReceiptButton/ViewSingleBatchReceipt/ViewSingleBatchReceipt';
import { useI18nContext } from '../../../contexts/I18nContext';
import { CurrencyModule } from '../../../util/Currency';
import ArticleIcon from '@mui/icons-material/Article';
import { Tooltip } from '@material-ui/core';

const ClientOrderReceiptsButton: React.FC<ClientOrderReceiptsButtonProperties> = ({
                                                                          showIcon = true,
                                                                          showText = true,
                                                                          onlyIcon = false,
                                                                          className = '',
                                                                          from,
                                                                          to,
                                                                          clientId,
                                                                          clientName,
                                                                          rounded = false,
                                                                          size = ButtonSize.DEFAULT,
                                                                          type = ButtonType.DEFAULT
                                                                      }) => {
    const classes = useStyles(showText);
    const i18n = useI18nContext();

    const commonContext = useCommonContext();
    const store = new ClientOrderReceiptsStore(commonContext, from, to, clientId);

    const handleGenerate = () => {
        if (store.selectedOrders.length > 0) {
            store.showReceipt = true;
        }
    };

    const handleOnclick = async () => {
        await store.openModal();
        await store.loadOrders();
    }

    const onCloseModal = () => {
        store.closeModal();
    }

    const getFriendlyServiceName = (serviceName: string) => {
        switch(serviceName) {
            case 'MONEY_DELIVERY': return 'Envío';
            case 'ARTICLE_DELIVERY': return 'Artículo';
            case 'MISCELLANY': return 'Miscelánea';
            case 'TOPUP': return 'Recarga';
            case 'SHOP': return 'Venta';
            case 'PACKAGE_DELIVERY': return 'Paquete';
            default: return serviceName;
        }
    };

    const text = `Factura compuesta`;
    const title = `Factura compuesta para ${clientName}`;
    const Icon = ArticleIcon;
    const Btn = () => {
        if (onlyIcon) {
            return <ArticleIcon
                fontSize="small"
                onClick={handleOnclick}
            />
        }
        if (rounded) {
            return <RoundedButton
                onClick={handleOnclick}
                className={className}
                tooltip={!showText ? text : ""}
                text={showText ? text : ""}
                type={type}
                icon={showIcon ? <Icon/> : <></>}
            />
        }
        return <Button
            text={showText ? text : ""}
            className={className}
            tooltip={!showText ? text : ""}
            size={size}
            onClick={handleOnclick}
            type={type}
            startIcon={showIcon ? <Icon/> : <></>}
        />
    }
    return <Observer>
        {() => (
            <>
                <SidePanel
                        title={title}
                        open={store.isModalOpen}
                        onClose={onCloseModal}
                        className={classes.modal_container}
                    >
                        {store.orders.length > 0 ? (
                            <div className={classes.itens_container}>
                                <div className={classes.report_notice}>
                                    Seleccione las facturas para generar la factura.
                                </div>
                                <div className={classes.order_list_wrapper}>
                                    {store.orders.map(order => (
                                        <div
                                            key={order.id}
                                            className={`${classes.order_item} ${store.isOrderSelected(order) ? classes.selected : ""}`}
                                            onClick={() => store.toggleOrderSelection(order)}
                                        >
                                            {store.isOrderSelected(order) && <div className={classes.checkmark}>✓</div>}
                                            <div className={classes.order_info}>
                                                <span className={classes.order_number}>{order.orderNumber}</span> - <span className={classes.service_name}>{getFriendlyServiceName(order.serviceName)}</span>
                                            </div>
                                            <div>
                                                Destinatario: {order.contactName ?? '-'}
                                            </div>
                                            <div className={classes.order_meta}>
                                                <span className={classes.total}>{CurrencyModule.format(order.totalToPay)}</span>
                                                <span className={classes.status}>
                                                    {i18n.translate(order.status)}
                                                </span>
                                            </div>
                                        </div>

                                    ))}
                                </div>

                                <div className={classes.footer}>
                                    <Button
                                        text="Generar factura"
                                        disabled={store.selectedOrders.length === 0}
                                        onClick={handleGenerate}
                                        type={ButtonType.PRIMARY}
                                    />
                                </div>

                                {store.showReceipt && (
                                    <div className={classes.pdf_container}>
                                        <ViewSingleBatchReceipt productOrderIds={store.selectedOrders.map(o => o.id)} />
                                    </div>
                                )}
                            </div>
                        ) : (
                            !store.loading && <p>Nenhum pedido encontrado.</p>
                        )}
                    </SidePanel>
                    <Tooltip title={'Factura compuesta del mismo remitente'}>
                        <div><Btn/></div>
                    </Tooltip>
            </>
        )}
    </Observer>
}

export default ClientOrderReceiptsButton;
